export const GET_IMPORT_STATUS_DETAIL = "GET_IMPORT_STATUS_DETAIL";
export const START_LOADING_IMPORT_STATUS_DETAIL = "START_LOADING_IMPORT_STATUS_DETAIL";
export const ERROR_LOADING_IMPORT_STATUS_DETAIL = "ERROR_LOADING_IMPORT_STATUS_DETAIL";
export const STOP_LOADING_IMPORT_STATUS_DETAIL = "STOP_LOADING_IMPORT_STATUS_DETAIL";
export const RESET_IMPORT_STATUS_DETAIL = "RESET_IMPORT_STATUS_DETAIL";
